export var MitreSelectTestSubjects;
(function (MitreSelectTestSubjects) {
    MitreSelectTestSubjects["ClearAllTagsButton"] = "clear-all-tags-button";
    MitreSelectTestSubjects["MitreSelectContainer"] = "mitre-select-container";
    MitreSelectTestSubjects["AddTagButton"] = "add-tag-button";
    MitreSelectTestSubjects["TacticSelect"] = "tactic-select";
    MitreSelectTestSubjects["TechniqueSelect"] = "technique-select";
    MitreSelectTestSubjects["SubTechniqueSelect"] = "sub-technique-select";
    MitreSelectTestSubjects["SaveTagButton"] = "save-tag-button";
    MitreSelectTestSubjects["RemoveTagButton"] = "remove-tag-button";
    MitreSelectTestSubjects["ClearAllButton"] = "clear-all-button";
    MitreSelectTestSubjects["TagsContainer"] = "tags-container";
    MitreSelectTestSubjects["InvalidMitreTagAlert"] = "invalid-mitre-tag";
})(MitreSelectTestSubjects || (MitreSelectTestSubjects = {}));
//# sourceMappingURL=mitre-select.enum.js.map